import { render } from "./eventlist.vue?vue&type=template&id=21d10c4f&scoped=true"
import script from "./eventlist.vue?vue&type=script&lang=js"
export * from "./eventlist.vue?vue&type=script&lang=js"

import "./eventlist.vue?vue&type=style&index=0&id=21d10c4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d10c4f"]])

export default __exports__